export var DICE_ADVERTISING_PLUGIN_ID="@dicetechnology/doris-plugin-dice-advertising";